// War-report headline recap (GDD §10): the Match keeps the latest headline-worthy events in a fixed ring, so a war of
// any length costs the same memory.

import type { SimEvent, SimEventKind } from '@taxwar/net'

const RECAP_CAPACITY = 48

/** Which event kinds the recap keeps. Every kind must decide here, so a new kind cannot be silently left out. */
const RECAP_KINDS: Readonly<Record<SimEventKind, boolean>> = {
  unitDeployed: false,
  unitSpawned: false,
  unitKilled: false,
  buildingBuilt: false,
  buildingDestroyed: true,
  cityFallen: true,
  cityRestored: true,
  cityCaptured: true,
  strikeLaunched: true,
  strikeIntercepted: true,
  strikeImpact: false,
  sanctionsApplied: true,
  taxChanged: true,
  approvalThreshold: true,
  phaseChanged: true,
  commandRejected: false,
  outcomeDecided: true,
}

export class RecapBuffer {
  private readonly ring: SimEvent[] = []
  /** Next write slot once the ring is full (= the oldest kept event). */
  private next = 0

  record(events: readonly SimEvent[]): void {
    for (let i = 0; i < events.length; i++) {
      const event = events[i] as SimEvent
      if (!RECAP_KINDS[event.kind]) continue
      if (this.ring.length < RECAP_CAPACITY) {
        this.ring.push(event)
      } else {
        this.ring[this.next] = event
        this.next = (this.next + 1) % RECAP_CAPACITY
      }
    }
  }

  /** The kept events, oldest first. */
  snapshot(): readonly SimEvent[] {
    return [...this.ring.slice(this.next), ...this.ring.slice(0, this.next)]
  }
}
